<script>
// Name: item-certificate
import Vue from 'vue'
import Component from './component'
Vue.component(
  'item-certificate',
  Component
)
</script>



// WEBPACK FOOTER //
// index.vue?3b857aa2